import { Page } from '@zillow/constellation';
import { useRouter } from 'next/router';
import { PAGE_NAME } from '../constants/pageName';

export type Page = (typeof PAGE_NAME)[keyof typeof PAGE_NAME];

const pathnameToPageMap: { [key: string]: Page } = {
  '/inbox': PAGE_NAME.inbox,
  '/lead-management': PAGE_NAME.leadManagement,
  '/leads': PAGE_NAME.leads,
} as const;

export default function usePageIdentifier(): Page {
  const router = useRouter();

  for (const [key, page] of Object.entries(pathnameToPageMap)) {
    if (router.pathname.includes(key)) {
      return page;
    }
  }

  // Default to 'inbox' if no match is found
  return 'inbox';
}
